import React, { useEffect } from 'react';
import { Dialog, Stack } from '@mui/material';

import { useAppDispatch, useAppSelector } from 'hooks';
import { setClose } from 'store/reducers/notifySlice';

import { colors } from 'utilities';
import { useTranslates } from 'providers/translates';

export const NotifyNew: React.FC = () => {
  const dispatch = useAppDispatch();
  const notifyStore = useAppSelector((state) => state.notify);
  const { translates } = useTranslates();
  const notifyPopup = translates?.quiltBuilder?.notifyPopup;
  const somethingWentWrongPopUp = translates?.quiltBuilder?.somethingWentWrongPopUp;
  const defaultText = somethingWentWrongPopUp?.somethingWentWrongText ?? 'Something went wrong. Please try again later.';

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (notifyStore.isOpen) {
      timer = setTimeout(() => {
        dispatch(setClose());
      }, 10000);
      return () => clearTimeout(timer);
    }
    return () => clearTimeout(timer);
  }, [dispatch, notifyStore.isOpen]);

  return (
    <Dialog onClose={() => dispatch(setClose())} open={notifyStore.isOpen}>
      <Stack
        justifyContent="center"
        alignItems="center"
        p={{ xs: 2, md: 4 }}
        spacing={4}
        minWidth={{ xs: '250px', md: '400px' }}
      >
        <span style={{ textAlign: 'center', lineHeight: '32px', color: colors.dark_grey }}>
          {notifyStore.message ?? defaultText}
        </span>
        <button className="customButton" onClick={() => dispatch(setClose())}>
          {notifyPopup?.okayButtonLabel ?? 'OK'}
        </button>
      </Stack>
    </Dialog>
  );
};
